import Rete, { Socket} from "rete";
import VueControl from "./ToggleControl.vue";
import AnyTypeSocket from "../../Utils/CommonSockets";

export class ToggleControl extends Rete.Control {
  constructor(emitter, key, onLab,offLab) {
    super(key);
    this.render = "vue";
    this.component = VueControl;
    this.props = { emitter, ikey: key, OnName:onLab, OffName:offLab };
  }

  setValue(val) {
    this.vueContext.value = val;
  }
}

const ToggleSocket = new Socket("Toggle");
ToggleSocket.combineWith(AnyTypeSocket);
export { ToggleSocket };